module.exports = __webpack_public_path__ + "static/media/vandal.2d236c45.png";